/*
Doors and Frames
 */

const name = 'Doors & Frames'
const id = 'ArL8snrFfPPS1rLwltUX'

export default {
  name,
  id
}
